import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseCarousel from './HseCarousel.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseCarousel;

/* template */
var __vue_render__ = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-Carousel",class:( _obj = {}, _obj[("hse-Carousel_variant_" + _vm.variant)] = _vm.variant, _obj["hse-Carousel_with-navigation"] = _vm.navigation, _obj )},[_c('div',{ref:"container",staticClass:"hse-Carousel__container swiper-container"},[_c('div',{staticClass:"hse-Carousel__slides swiper-wrapper",class:_vm.classes.slides},[_vm._t("default")],2)]),_vm._v(" "),(_vm.navigation)?_c('div',{staticClass:"hse-Carousel__footer",class:( _obj$1 = {
        grid: _vm.variant === 'fullScreen'
      }, _obj$1[_vm.classes.footer] = _vm.classes.footer, _obj$1 )},[_c('div',{staticClass:"hse-Carousel__footerContent col-mobile-small-4 col-mobile-large-4 col-tablet-small-8 col-tablet-large-12 col-desktop-small-12 col-desktop-medium-12 col-desktop-large-16",class:{
          'tablet-large-down-hide': _vm.variant === 'horizontalMultiple'
        }},[_c('div',{staticClass:"hse-Carousel__navigation",class:_vm.classes.navigation},[_c('div',{staticClass:"hse-Carousel__navigationButtons",class:_vm.classes.navigationButtons},[_c('div',{staticClass:"hse-Carousel__navigationButton hse-Carousel__navigationButton_prev swiper-button-prev",class:_vm.classes.navigationButton},[_c('HseIconButton',{attrs:{"icon":_vm.IconActionArrowKeyboardLeft,"aria-label":"Предыдущий слайд","type":"button","variant":"pagination"},on:{"click":_vm.onPrevClick}})],1),_vm._v(" "),_c('div',{staticClass:"hse-Carousel__navigationButton hse-Carousel__navigationButton_next swiper-button-next",class:_vm.classes.navigationButton},[_c('HseIconButton',{attrs:{"icon":_vm.IconActionArrowKeyboardRight,"aria-label":"Следующий слайд","type":"button","variant":"pagination"},on:{"click":_vm.onNextClick}})],1)]),_vm._v(" "),(_vm.showNavigationText)?_c('div',{staticClass:"hse-Carousel__navigationText",class:_vm.classes.navigationText},[_c('span',[_vm._v(_vm._s(_vm.state.currentSlideNumberText))]),_vm._v(" "),_c('span',{staticClass:"hse-Carousel__navigationTextDelimiter"},[_vm._v("/")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.state.totalSlidesCountText))])]):_vm._e()])])]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
